export const API_URL = process.env.REACT_APP_API_URL;
export const GOOGLE_ANALYTICS_ID = process.env.REACT_APP_GOOGLE_ANALYTICS_ID;
export const telegramLink = process.env.REACT_APP_TELEGRAM_CHANNEL;
export const twitterLink = process.env.REACT_APP_TWITTER;
export const instagramLink = process.env.REACT_APP_INSTAGRAM;
export const TELEGRAM_BOT_TOKEN = process.env.REACT_APP_TELEGRAM_BOT_TOKEN;
